var _defs, _tspan, _tspan2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreetlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1035.76 379.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 17
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "StreetRide",
    style: {
      filter: "url(#drop-shadow-1)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1023.76,165.91c-64.48-35.19-130.3-41.72-198.2-17.31-.18-.77-.36-1.53-.54-2.3,1.02-1.05,1.89-2.58,3.08-3.09,28.13-12.01,57.19-18.96,87.19-17.85,27.38,1.01,54.3,6.36,80.42,16.42,4.81,1.85,9.83,3,14.72,4.46,3.2-9.24-1.04-31.65-7.57-36.64-3.19-2.43-7.53-3.03-11.44-3.98-20.78-5.02-41.69-9.35-62.35-14.96-16.92-4.59-33.63-10.28-50.28-16.12-19.8-6.94-39.38-14.7-59.12-21.85-16.26-5.89-32.46-12.13-48.97-16.9-19.19-5.55-38.53-10.93-58.09-14.05-21.61-3.45-43.51-5.48-65.32-5.91-29.74-.59-59.55.03-89.26,1.82-19.19,1.16-38.2,5.65-56.52,12.96-19.72,7.87-39.55,15.43-58.98,24.17-29.2,13.14-56.92,29.96-84.22,47.73-2.42,1.58-5.42,2.63-8.19,2.74-40.42,1.53-80.89,1.93-121.25,4.59-24.85,1.63-49.65,5.75-74.24,10.4-22.2,4.19-44.31,9.64-66.05,16.31-25.82,7.92-50.97,18.46-75.06,32.06-1.18.67-2.62.73-3.94,1.08-.24-.49-.47-.99-.71-1.48,1.07-.99,2.03-2.29,3.24-2.93,13.49-7.07,26.71-15.02,40.6-20.8,20.82-8.66,41.84-17.09,63.29-23.2,25.03-7.13,50.52-12.34,76-17.07,19.89-3.69,40.01-6.12,60.11-7.77,31.51-2.59,63.11-3.59,94.6-6.39,6.24-.56,12.15-6.18,18.19-9.51,19.95-11.01,39.65-22.68,59.9-32.87,18.76-9.43,37.9-18.03,57.28-25.57,14.7-5.72,29.91-10.03,45.14-13.53,49.11-11.29,98.8-9.33,148.29-5.71,24.74,1.81,49.35,7.61,73.78,13.07,18.83,4.21,37.41,10.16,55.86,16.31,23.9,7.97,47.56,16.94,71.34,25.39,15.57,5.54,31.03,11.64,46.81,16.19,19.16,5.52,38.52,10.37,57.99,14.1,8.71,1.67,17.91.11,26.87-.36,5.12-.27,10.21-1.38,15.33-1.91,3.15-.33,4.03,1.85,2.89,4.85-1.02,2.68-2.39,5.23-3.9,7.59-3.24,5.08-4.65,10.12-2.68,16.6,4.11,13.53,6.5,27.49,5.3,41.97-.24,2.86-.82,5.67-1.36,9.27Z",
    style: {
      fill: "#00aeef",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 328.1)",
    style: {
      fontFamily: "ModulusPro-Regular, &apos",
      fontSize: "223.47px"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      letterSpacing: "-.01em"
    }
  }, "s"), _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 92.96,
    y: 0
  }, "t")), /*#__PURE__*/React.createElement("tspan", {
    x: 169.39,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 271.73,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 389.73,
    y: 0,
    style: {
      letterSpacing: "-.02em"
    }
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 504.81,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "t r"), /*#__PURE__*/React.createElement("tspan", {
    x: 760.23,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 795.09,
    y: 0,
    style: {
      letterSpacing: "-.01em"
    }
  }, "d"), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 916.21,
    y: 0
  }, "e")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreetlogo);
export default __webpack_public_path__ + "static/media/streetlogo.ea9ee74f3a430607f6c5d6136bafbde0.svg";
export { ForwardRef as ReactComponent };